import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marinecancelpayment',
  templateUrl: './marinecancelpayment.component.html',
  styleUrls: ['./marinecancelpayment.component.scss']
})
export class MarinecancelpaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
